export const environment = {
  production: false,
  preProduction: true,
  useEmulators: false,
  cf_url: 'https://cf.ap1.com.br',
  fbFunctionsRegion: 'southamerica-east1',
  familyRules: ['-L9KpEriBVVw_suFofuV', '-NAoclMfcep6ttJH4bsG'],
  solCluster: 'devnet',
  firebase: {
    apiKey: 'AIzaSyAfKK8FW2p8gEzQ0dQ9sxLK4NoCgUqMusg',
    authDomain: 'bolco-2018.firebaseapp.com',
    databaseURL: 'https://bolco-2026.firebaseio.com',
    projectId: 'bolco-2018',
    storageBucket: 'bolco-2026.appspot.com',
    messagingSenderId: '910691369951',
    appId: '1:910691369951:web:6310a0b3fb7b48e890ba6a',
    measurementId: 'G-ZPP5Z60110',
    vapidKey: 'BOcO9-D_kJfsCBD0TRF7C2r3VOKpi6uaAd5KDjVYHH4jA8i9Zvq6yREnQFcLi1AhoJifPTSUChXkoKEzm-8nCp4',
  },
};
